<template>
  <egg-description
    title="aboutus.ourServices"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconDeepBlue', imgFormat: 'svg' }"
    :eggImgObj="{ componentName: 'aboutus', imgName: 'ourServices', imgFormat: 'svg', position: 'left' }"
    :isShowStarBackgroundLeft="false"
    :starBackgroundRightObj="{ componentName: 'shared', imgName: 'starGroupIconBrownRight', imgFormat: 'svg', top: '-30%' }"
    textMode="text"
    description="aboutus.ourServicesDesc"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useAboutUsStore } from "@/stores/aboutus";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const aboutusStore = useAboutUsStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>